module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-us":{"DailyReport":"Daily Report","WeeklyReport":"Weekly Report","MonthlyReport":"Monthly Report"}}')
  delete Component.options._Ctor
}
